module.exports = __webpack_public_path__ + "assets/notification-bell.1795ff75372e7b05f274606a41c5cee5.svg";